import { useCookie } from "#app"
import { parseJwt, willExpireSoon, isExpired } from "../utils/auth"
import { isPublicRoute, loginPathFor } from "../utils/safeRedirect"
export default defineNuxtRouteMiddleware((to, from) => {
	const token: string | undefined | null = useCookie("auth_token").value

	const isPublic = isPublicRoute(to.path)

	// Redirect to login if no token and not on public route. The intended path rides along in
	// ?redirect= so a maker following a hub link from an email lands on that page once they have
	// signed in, rather than on the dashboard.
	if (!token && !isPublic) {
		return navigateTo(loginPathFor(to.fullPath))
	}
	if (token) {
		try {
			if (isExpired(token)) {
				useCookie("auth_token").value = null
				if (!isPublic) {
					return navigateTo(loginPathFor(to.fullPath))
				}
			}
			const payload = parseJwt(token)
			const expiresSoon = willExpireSoon(payload.exp)
			if (expiresSoon && import.meta.client) {
				window.dispatchEvent(new Event("token-expiring"))
			}
		} catch {
			useCookie("auth_token").value = null
			return navigateTo("/login")
		}
	}
})
